var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancialImageBackgroud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 367.757,
    height: 420,
    viewBox: "0 0 367.757 420",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72632",
    "data-name": "Path 72632",
    d: "M382.057,307.39c0,111.675-71.5,138.124-171.4,138.124S81.723,442.88,81.723,331.2-47.755,25.514,52.144,25.514,382.057,195.715,382.057,307.39Z",
    transform: "translate(-14.3 -25.514)",
    fill: "#f2f2f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialImageBackgroud);
export default __webpack_public_path__ + "static/media/financialImageBackgroud.9218a70e7f22b52fdf78782d69832672.svg";
export { ForwardRef as ReactComponent };